import React from 'react'
import Signup from '../../Page/Signup'

function Main() {
  return (
    <>
      <Signup />
    </>
  )
}

export default Main
